import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'

import PaperBlock from "../../ui/PaperBlock"

/**
 * selected
 * 
 * 
 * onCreateUserClick
 * onEditUserClick(user)
 * onDeleteUserClick(user)
 */


class ControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Создать пользователя"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateUserClick === "function") {
							this.props.onCreateUserClick()
						}
					}}
				>
					<CreateIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать пользователя"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditUserClick === "function") {
							this.props.onEditUserClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
					</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить пользователя"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteUserClick === "function") {
							this.props.onDeleteUserClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>

	}

}

export default ControlPanel
